import {
  Button,
  Flex,
  Box,
  SimpleGrid,
  VStack,
  List,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { FC, useMemo, useState } from 'react';
import { HotelFeatureFragmentFragment } from '../../../generated/types';
import log from '../../../utils/logger';

interface FeatureListGroupedProps {
  features: HotelFeatureFragmentFragment[];
}

const FeatureListGrouped: FC<FeatureListGroupedProps> = ({ features }) => {
  const [showFull, setShowFull] = useState(false);

  const groupedFeatures = useMemo(() => {
    const groups: Record<
      number,
      {
        group: {
          id: number;
          name: string;
        };
        features: HotelFeatureFragmentFragment[];
      }
    > = {};

    features.forEach((feature) => {
      if (!groups[feature.category.id]) {
        groups[feature.category.id] = {
          group: feature.category,
          features: [],
        };
      }

      groups[feature.category.id].features.push(feature);
    });

    return groups;
  }, [features]);

  log('FeatureListGrouped', groupedFeatures);

  return (
    <>
      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
        }}
        spacing={6}
      >
        {Object.keys(groupedFeatures).map((categoryId, i) => {
          if (!showFull && i >= 2) return null;

          const groupData = groupedFeatures[categoryId];

          return (
            <Box key={i}>
              <Box fontWeight="bold" fontSize="xl">
                {groupData.group.name}
              </Box>
              <UnorderedList mt={1} spacing={2}>
                {groupData.features.map((feature) => (
                  <ListItem key={`${groupData.id}-${feature.id}`}>
                    {feature.name}
                  </ListItem>
                ))}
              </UnorderedList>
            </Box>
          );
        })}
      </SimpleGrid>
      {!showFull && Object.keys(groupedFeatures).length > 2 && (
        <Flex justifyContent={'center'} marginTop={8}>
          <Button
            width="100%"
            variant="bikerbetten"
            onClick={() => setShowFull(true)}
          >
            Mehr anzeigen
          </Button>
        </Flex>
      )}
    </>
  );
};

export default FeatureListGrouped;
